import React from 'react'
import { formatMoney, formatPercentage } from '../../packages/utils/numberFormatters'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n/i18n'
import { EnrichedWarrantEntity } from 'types/WarrantEntity'

export const formatWarrantSubPrice = (
    warrant: Pick<EnrichedWarrantEntity, 'currentSubscriptionPeriod'>,
    locale: string,
    currency: string | null,
) => {
    if (!warrant) return ''

    const subPeriod = warrant.currentSubscriptionPeriod
    const warrantSubPrice = subPeriod?.warrantSubPrice

    return warrantSubPrice ? (
        formatMoney(warrantSubPrice, { locale, currencySymbol: currency, minDecimals: 2, maxDecimals: 5 })
    ) : (
        <div>
            <div>
                {i18n.t('site.pricing.vwapDiscount')}{' '}
                {formatPercentage(subPeriod?.vwapDiscount, { locale, minDecimals: 0 })}
            </div>
            <div>
                {i18n.t('site.pricing.min')}{' '}
                {formatMoney(subPeriod?.priceMin, {
                    locale,
                    currencySymbol: currency,
                    minDecimals: 2,
                    maxDecimals: 5,
                }) || i18n.t('site.pricing.parValue')}
                {subPeriod?.priceMax && (
                    <>
                        , {i18n.t('site.pricing.max')}{' '}
                        {formatMoney(subPeriod?.priceMax, {
                            locale,
                            currencySymbol: currency,
                            minDecimals: 2,
                            maxDecimals: 5,
                        })}
                    </>
                )}
            </div>
        </div>
    )
}

export function WarrantSubPrice({
    warrant,
}: {
    warrant: Pick<EnrichedWarrantEntity, 'currentSubscriptionPeriod' | 'currency'>
}) {
    const { i18n } = useTranslation()
    const locale = i18n.language

    return <>{formatWarrantSubPrice(warrant, locale, warrant.currency)}</>
}
